
export const ahfrrActionTypes = {
    getFeedData: "@@ahfrr/getFeedData",
    showDescription: '@@ahfrr/ShowDescription',
    showReponsiblity: '@@ahfrr/ShowREsponsiblity',
    showNetMargin: '@@ahfrr/ShowNetMargin',
    showGrossMargin: '@@ahfrr/ShowGrossMarge',
    showSettings:'@@ahfrr/ShowSettings',
    showDashboard:'@@ahfrr/ShowDashboard',
    showWishlist:'@@ahfrr/ShowWishlist',
    showMarketplace:'@@ahfrr/ShowMarketplace',
    showSwiped:'@@ahfrr/ShowSwiped',
    showAccount:'@@ahfrr/ShowAccount',
    showModal:'@@ahfrr/ShowModal',
    hideModal:'@@ahfrr/HideModal',
    };